import { render, staticRenderFns } from "./tanimlama.vue?vue&type=template&id=5934eb8c&scoped=true&"
import script from "./tanimlama.vue?vue&type=script&lang=js&"
export * from "./tanimlama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5934eb8c",
  null
  
)

export default component.exports